import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// `withCredentials: true` sends the httpOnly `access_token` cookie set at login.
// No client-side token storage — XSS-safe.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
